import { api } from "@/api";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { removeNullOrEmptyKeys, sleep } from "@/shared/utils"
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";

export type SetConfigurationRequest = {
    //Venta
    paySeparately: boolean,
    requireVentaAuthorization: boolean,
    defaultPrecioIndex: number,
    articuloNombreMaxLength: number,

    //Factura
    marginTopPx: number,
    itemsPerPage: number,
    horizontal: boolean,
    genericClientId: string,
    modeTicket: boolean,
    printFont: string,
    printFontSize: number,
    printPaddingRight: number,
    printPaperWidth: string,
    ticketHeader: string,
    ticketItemIdentifier: string,
    ticketFooter: string,
    kudeItemsPerPage: number,
}

export async function SetConfiguration(request: SetConfigurationRequest) {
    await sleep(1000);
    await api.put("configuration", removeNullOrEmptyKeys(request));
}

export function useSetConfigurationMutation(mutationConfig: MutationConfig<void, SetConfigurationRequest> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: SetConfiguration,
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["configuration"] });
        },
    })
}

export interface SetConfigurationMutationProps {
    mutationConfig?: MutationConfig<void, SetConfigurationRequest>
    children?: (mutationResult: MutationResult<void, SetConfigurationRequest>) => ReactNode
}

export function SetConfigurationMutation({
    mutationConfig,
    children
}: SetConfigurationMutationProps) {
    const mutationResult = useSetConfigurationMutation(mutationConfig);
    return children && children(mutationResult);
}